import styles from './index.module.less';
import { useTranslation } from 'next-i18next';

// 文案内容对象

export default function SectionWhat() {
  const { t } = useTranslation();
  const CONTENT = {
    title: t('CAM_WHAT_TITLE'),
    subtitle: t('CAM_WHAT_DESC'),
    features: [
      {
        number: '1',
        title: t('CAM_WHAT_FEATURES_MONITOR_TITLE'),
        description: t('CAM_WHAT_FEATURES_MONITOR_DESC'),
        image: '/images/cam-model-protection/1.png', // 占位图片路径
      },
      {
        number: '2',
        title: t('CAM_WHAT_FEATURES_REMOVE_TITLE'),
        description: t('CAM_WHAT_FEATURES_REMOVE_DESC'),
        image: '/images/cam-model-protection/2.png', // 占位图片路径
      },
      {
        number: '3',
        title: t('CAM_WHAT_FEATURES_REVERSE_TITLE'),
        description: t('CAM_WHAT_FEATURES_REVERSE_DESC'),
        image: '/images/cam-model-protection/3.png', // 占位图片路径
      },
    ],
  };

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h2 className={styles.title}>{CONTENT.title}</h2>
        <p className={styles.subtitle}>{CONTENT.subtitle}</p>

        <div className={styles.featuresGrid}>
          {CONTENT.features.map((feature, index) => (
            <div key={index} className={styles.featureCard}>
              <div className={styles.cardContent}>
                <div className={styles.cardText}>
                  <span className={styles.number}>{feature.number}</span>
                  <h3 className={styles.featureTitle}>{feature.title}</h3>
                  <p className={styles.featureDescription}>{feature.description}</p>
                </div>
                <div className={styles.cardImage}>
                  <img src={feature.image} alt={feature.title} />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
